import React, { Component } from 'react'
import './apiLoader.style.scss'

class ApiLoader extends Component {
  render() {
    return (
      <>
        <div id="overlay">
          <div className="justify-content-between mx-5 mt-3 mb-5">
            <div className="spinner-border text-loader-info align-self-center">
              <br />
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default ApiLoader

